import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { ExchangeTradedInstrument } from '../../Models/Domains/Investment/ExchangeTradedInstrument';
import { ExchangeTradedInstrumentSearchQuery } from '../../Models/Domains/Investment/ExchangeTradedInstrumentSearchQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class ExchangeTradedInstrumentSearchQueryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: ExchangeTradedInstrumentSearchQuery, hierarchyId: string): Promise<ResultPageModel<ExchangeTradedInstrument>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/ExchangeTradedInstrumentSearchQuery/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query, hierarchyId: hierarchyId }

    return AjaxWrapper.post<ResultPageModel<ExchangeTradedInstrument>, any>(url, data);
  }
}

